import { isHtml } from '@shared/helpers/text/isHtml';
import parse from 'html-react-parser';

import { Typography } from '@mui/material';

import { sxStyle } from './styles';

const parseContent = value => {
  if (typeof value !== 'string') {
    return value;
  }

  return isHtml(value) ? parse(value) : value;
};

const CommentContent = ({ children }) => {
  if (!children) {
    return null;
  }

  const content = parseContent(children);

  return (
    <Typography
      sx={{
        ...sxStyle.subTitle,
        whiteSpace: 'pre-line',
      }}
      component="div"
    >
      {content}
    </Typography>
  );
};

export default CommentContent;
